<template>
  <div :class="half ? 'sm:col-span-1' : 'sm:col-span-2'">
    <dt class="text-lg font-bold text-gray-900">
      <slot name="title">{{ title }}</slot>
    </dt>
    <p class="text-sm font-medium text-gray-500" v-if="subtitle">
      <slot name="subtitle">{{ subtitle }}</slot>
    </p>
    <dd class="mt-5 text-sm text-gray-900 w-full grid gap-x-4 gap-y-4 grid-cols-1 sm:grid-cols-2">
      <slot>{{ value || '—' }}</slot>
    </dd>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    value: String,
    half: Boolean,
  },
}
</script>
